import validations from '../frontend/components/form/validations';
/**
 * required fields:
 * * title
 * * description
 * * logo
 * * Background image
 */
export default function validateProfile(profile) {
    const errors = {};
    if (!profile.companyName || validations.isEmpty(profile.companyName)) {
        errors.companyName = 'selskapsnavn';
    }

    if (!profile.description) {
        errors.description = 'om oss';
    }

    if (!profile.logo) {
        errors.logo = 'logo';
    }

    if (!profile.background) {
        errors.background = 'bakgrunnsbilde';
    }

    return errors;
}
